// extracted by mini-css-extract-plugin
export default {"main":"Tictac_main__u+4Vw","grid":"Tictac_grid__e3byR","grid-inline":"Tictac_grid-inline__DHQz8","text":"Tictac_text__rqh41","button":"Tictac_button__+pQjg"};